import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { sanitizeRedirect } from "../lib/redirect";

export default function AuthCallback() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    // Honor a `next=` query param (set by login page when there's a ?redirect=).
    // Sanitize it against open-redirect attacks — external URLs are silently
    // replaced with the site root by sanitizeRedirect().
    const sp = new URLSearchParams(window.location.search);
    const rawNext = sp.get("next");
    // Wishlist is the historical landing page when the login was NOT triggered
    // by a specific destination. Keep it when there's no `next` at all so we
    // don't regress that UX.
    const nextPath = rawNext ? sanitizeRedirect(rawNext) : "/wishlist";
    if (!m) {
      nav(nextPath, { replace: true });
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        await checkAuth();
        nav(nextPath, { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        nav("/", { replace: true });
      }
    })();
  }, [nav, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F7]">
      <div className="text-center">
        <div className="w-3 h-3 bg-[#B8A88A] rounded-full pulse-accent mx-auto mb-6" />
        <p className="font-italic-display text-xl text-[#6B6B6B]">Finalizando seu acesso...</p>
      </div>
    </div>
  );
}
